import { addToChainAfter, addToChainBefore, ApiHandlerDiscreteParameter, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    PopulateApiParameter,
    SetCartStatus,
    SetPaymentMethod,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { clearZeroTotalPayment } from "@tSurya/Common/Utilities/checkoutPaymentMethod";
import { PaymentSplitChoice } from "@tSurya/Common/Utilities/paymentBreakdown";
export interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    isPending?: boolean;
    isAdyenDropIn?: boolean;
    adyenPspReference?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    payerId: string;
    maskedCardNumber: string;
    /**
     * SR-1544 split payment choice made in the Payment Breakdown section. Sent to the
     * backend as the "paymentSplitChoice" cart custom property so the
     * ProcessCreditCardTransactions handler knows whether to charge both entities
     * (prepayAll), only the MG+BW portion (prepayMgbwOnly - SURYA/GV goes on terms),
     * or nothing (payAllOnTerms - submitted without card data as a terms order).
     */
    paymentSplitChoice?: PaymentSplitChoice;
    antiFraudSessionId: string;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;

/**
 * Writes the user's payment split choice onto the cart custom properties so it travels
 * with the PUT cart payload. Server-side, BaseApiController copies model Properties into
 * UpdateCartParameter.Properties and the vendor CopyCustomPropertiesToCart handler
 * (Order 600) persists them on the CustomerOrder before ProcessCreditCardTransactions
 * (Order 2800) reads it.
 */
export const SetPaymentSplitChoice: HandlerType = props => {
    const choice = props.parameter.paymentSplitChoice;
    if (!choice) {
        return;
    }

    props.cartToUpdate.properties = {
        ...(props.cartToUpdate.properties || {}),
        paymentSplitChoice: choice,
    };
};

addToChainAfter(chain, SetCartStatus, SetPaymentSplitChoice);

export const SetZeroTotalPayment: HandlerType = props => {
    if (clearZeroTotalPayment(props.cartToUpdate)) {
        return;
    }

    return SetPaymentMethod(props);
};

replaceInChain(chain, SetPaymentMethod, SetZeroTotalPayment);

export const ClearZeroTotalPaymentBeforeSubmit: HandlerType = props => {
    clearZeroTotalPayment(props.cartToUpdate);
};

addToChainBefore(chain, PopulateApiParameter, ClearZeroTotalPaymentBeforeSubmit);


